import axios from 'axios'
import React, { useEffect,useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Divider from '@mui/material/Divider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useTheme } from '@mui/material/styles';
import Logo from "../images/nag_kitchen_logo.png"; // Replace with actual path
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material';



import {
    Typography,
    Container,
    TextField,
    Card,
    CardHeader,
    CardContent

} from '@mui/material';
import axiosInstance from "../axiosConfig";
import Banner from "../images/banner.png";
import {useAuth} from "./AuthContext";

export default function CateringEnquiry() {
    const [vegAppetizers, setVegAppetizers] = useState([])
    const [nonVegAppetizers, setNonVegAppetizers] = useState([])
    const [vegRice, setVegRice] = useState([])
    const [nonVegRice, setNonVegRice] = useState([])
    const [nonVegFry, setNonVegFry] = useState([])
    const [vegFry, setVegFry] = useState([])
    const [nonVegGravies, setNonVegGravies] = useState([])
    const [vegGravies, setVegGravies] = useState([])
    const [selectedMenuItems, setSelectedMenuItems] = useState([])
    const [dal, setDal] = useState([])
    const [desserts, setDesserts] = useState([])
    const [sides, setSides] = useState([])
    const [pachadis, setPachadis] = useState([])
    const [breakfast, setBreakfast] = useState([])
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const serviceAPI = process.env.REACT_APP_API_SERVICE;

    const { isAuthenticated } = useAuth(); // Access authentication state

    const [formData, setFormData] = useState({
        customerName: '',
        email: '',
        phone:'',
        guests: '',
        eventDate: null,
        eventTime:'',
        address: '',
        adultCount:'',
        kidsCount:'',
        deliveryType:'',
        selectedMenuItems:'',
        cateringOrderNumber:''

    })
    const theme = useTheme();
    const [error, setError] = useState('')
    const navigate = useNavigate()

    const handleChange = (e) => {
        const { name, type, checked } = e.target;

        if (type === "checkbox") {

            if (checked) {
                // Add the item to the list of selected items if checked
                setSelectedMenuItems((prevItems) => [...prevItems, name]);
            } else {
                // Remove the item from the list if unchecked
                setSelectedMenuItems((prevItems) => prevItems.filter(item => item !== name));
            }
        }else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
        }
    };



    // Handle DatePicker change
    const handleDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            eventDate: date, // Update the dob field in formData
        }));
    };

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Veg_Rice`).then(response => {
            setVegRice(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Veg Rice Options", error)
        })
    }, []);

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Non_Veg_Rice`).then(response => {
            setNonVegRice(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Non Veg Rice Options", error)
        })
    }, []);

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Veg_Appetizer`).then(response => {
            setVegAppetizers(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Veg Appetizers Options", error)
        })
    }, []);

    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Non_Veg_Appetizer`).then(response => {
            setNonVegAppetizers(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Non Veg Appetizers", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Non_Veg_Gravies`).then(response => {
            setNonVegGravies(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the non veg gravies", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Veg_Gravies`).then(response => {
            setVegGravies(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Veg Gravies", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Veg_Fry`).then(response => {
            setVegFry(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Veg Fry", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Non_Veg_Fry`).then(response => {
            setNonVegFry(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the non veg fry", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Dhal_Pulusu`).then(response => {
            setDal(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Dal Menu", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Pachadi`).then(response => {
            setPachadis(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Pachadi Menu", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/Desserts`).then(response => {
            setDesserts(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Dessert Menu", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/sides`).then(response => {
            setSides(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Side Menu", error)
        })
    }, []);
    useEffect(() => {
        axiosInstance.get(`${serviceAPI}/cateringmenu/category/BreakFast`).then(response => {
            setBreakfast(response.data)
        }).catch((error) => {
            console.log("There was an error fetching the Breakfast Menu", error)
        })
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start loading
        setError(null);

        try {
            console.log('Selected Labels:', selectedMenuItems);
            formData.selectedMenuItems = selectedMenuItems;
            const response = await axios.post(`${serviceAPI}/orders/enquiry`, formData);

            if (response.status === 200) {
                setSuccessMessage('Catering Enquiry Request Submitted Successfully!');
                setDialogOpen(true);
            } else {
                const errorText = await response.text();
                setError(errorText);
            }
        } catch (err) {
            setError('An error occurred during catering form submission');
        } finally {
            setLoading(false);
        }
    };

  return (

    <Box sx={{
        backgroundImage: `url(${Banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center", // Centers vertically
        justifyContent: "flex-start", // Aligns the card to the left
        paddingLeft: "0%", // Adjust spacing from the left
        paddingTop: "75px", // Adjust spacing from the left

    }}>
    <Card sx={{
        width: 1800,
        border: "3px solid #356",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Translucent background
        backdropFilter: "blur(5px)", // Optional blur effect
        padding: "0px",
    }}>
    <CardHeader>
      Catering Form
    </CardHeader>
    <CardContent>
    <Container xs={12}>
    <Box sx={{ flexGrow: 1}}>
        <Typography
            variant="h4"
            component="div"
            sx={{
                fontWeight: "bold",
                color: "#333",
                [theme.breakpoints.down("sm")]: {
                    fontSize: "1.8rem" // Smaller font on mobile
                }
            }}
        >
            Catering with Us – Where Every Bite Feels Like Home!
        </Typography>

        <Typography
            variant="h5"
            component="div"
            sx={{
                color: "#555",
                [theme.breakpoints.down("sm")]: {
                    fontSize: "1.4rem" // Responsive font size
                }
            }}
        >
            Corporate events, weddings, or family gatherings — we got you covered!
        </Typography>

        <Typography
            variant="h6"
            component="div"
            sx={{
                color: "#777",
                marginTop: "8px",
                [theme.breakpoints.down("sm")]: {
                    fontSize: "1.1rem" // Smaller size for mobile
                }
            }}
        >
            For a quote, please fill out the form below.
        </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container xs={12} >
          <Grid item xs={4} style={{
              padding: '10px'
          }}>
             <TextField
                 label="Customer Name"
                 name="customerName"
                 fullWidth
                 value={formData.customerName}
                 onChange={handleChange}
                 required
                 sx={{
                     minWidth: '300px' // Adjust the value based on your design needs
                 }}
             />
          </Grid>

          <Grid item xs={4} style={{
              padding: '10px'}}>
            <TextField
              label="Email Address"
              name="email"
              fullWidth
              value={formData.email}
              onChange={handleChange}
              required
              sx={{
                  minWidth: '300px' // Adjust the value based on your design needs
              }}
            />
          </Grid>

            <Grid item xs={4} style={{
                padding: '10px'}}>
                <TextField
                    label="Phone Number"
                    name="phone"
                    fullWidth
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                />
            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'}}>
                <TextField
                    label="No of Guests"
                    name="guests"
                    fullWidth
                    value={formData.guests}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                />
            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Event Date"
                        value={formData.eventDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params}
                                                            helperText={error ? 'Date is required' : '' }
                                                            label="Event Date" required />}
                        sx={{
                            minWidth: '300px' // Adjust the value based on your design needs
                        }}
                    />
                </LocalizationProvider>


            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'
            }}>
                <TextField
                    label="Event Time"
                    name="eventTime"
                    type="time"
                    fullWidth
                    value={formData.eventTime}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                    InputLabelProps={{ shrink: true }} // Ensures the label stays consistent
                    inputProps={{
                        step: 1800, // 5-minute intervals
                        placeholder: '' // Removes the default `--:--` placeholder
                    }}
                />
            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'}}>
                <TextField
                    label="Home Address"
                    name="address"
                    fullWidth
                    value={formData.address}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                />
            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'}}>
                <TextField
                    label="No of Adults"
                    name="adultCount"
                    fullWidth
                    value={formData.adultsCount}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                />
            </Grid>
            <Grid item xs={4} style={{
                padding: '10px'}}>
                <TextField
                    label="No of kids"
                    name="kidsCount"
                    fullWidth
                    value={formData.kidsCount}
                    onChange={handleChange}
                    required
                    sx={{
                        minWidth: '300px' // Adjust the value based on your design needs
                    }}
                />
            </Grid>
            <Grid>
                <Grid item xs={4} style={{
                    padding: '10px'}}>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">Delivery Required</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="deliveryType"
                            value={formData.deliveryType}
                            onChange={handleChange}
                        >
                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                            <FormControlLabel value="No" control={<Radio />} label="No" />

                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>

        </Grid>

          <Divider sx={{ marginBottom: '16px' }} /> {/* Horizontal divider */}

          <Grid container  spacing={3}>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px', paddingBottom: '20px'}} display="flex" >
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>
                          Non Veg Appetizers
                      </Button>

                      <FormGroup>
                          {nonVegAppetizers.map((vr) => (
                              <FormControlLabel
                                  key={vr}
                                  control={
                                      <Checkbox
                                          checked={selectedMenuItems.includes(vr)}
                                          onChange={handleChange}
                                          name={vr}
                                      />
                                  }
                                  label={vr}
                                  sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}
                              />
                          ))}
                      </FormGroup>
                  </Box>
                </Grid>

              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Veg Appetizers</Button>
                      <FormGroup>
                          {vegAppetizers.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
                </Grid>
                <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex">
                    <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Veg Rice</Button>
                      <FormGroup>
                          {vegRice.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                          </FormGroup>

                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '200px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Non Veg Rice</Button>
                      <FormGroup>
                          {nonVegRice.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
         </Grid>
          <Grid container  spacing={3} >
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex" >
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Veg Gravies</Button>
                      <FormGroup>
                          {vegGravies.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>

              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Non Veg Gravies</Button>
                      <FormGroup>
                          {nonVegGravies.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}


                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '200px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Veg Fry</Button>
                      <FormGroup>
                          {vegFry.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '200px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Non Veg Fry</Button>
                      <FormGroup>
                          {nonVegFry.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr} />
                              }  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
          </Grid>
          <Grid container  spacing={3} >
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Breakfast</Button>
                      <FormGroup>
                          {breakfast.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}


                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Pachadi</Button>
                      <FormGroup>
                          {pachadis.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}


                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '200px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Dhal/Pulusu</Button>
                      <FormGroup>
                          {dal.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '200px' , paddingBottom: '20px'}} display="flex">
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Dessets</Button>
                      <FormGroup>
                          {desserts.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr} />
                              }  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
              <Grid item xl={2} lg={2} md={3} xs={4} sx={{minWidth: '100px' , paddingBottom: '20px'}} display="flex" >
                  <Box width="100%" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                      <Button variant="contained" sx={{ width: '200px' }}>Sides</Button>
                      <FormGroup>
                          {sides.map((vr, index) => (
                              <FormControlLabel control={<Checkbox checked={selectedMenuItems.includes(vr)}
                                                                   onChange={handleChange}
                                                                   name={vr}/>}  key={vr} label={vr} sx={{ '& .MuiTypography-root': { fontSize: '15px' } }}/>
                          ))}
                      </FormGroup>
                  </Box>
              </Grid>
          </Grid>
          <Grid container xs={12} alignItems="stretch">
              <Grid container xs={12}alignItems="stretch">
                  {error && (
                      <Grid item xs={6}>
                          <Typography color="error" variant="body2">
                              {error}
                          </Typography>
                      </Grid>
                  )}
                  <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      >
                      <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          sx={{ width: '300px' }}
                      >
                          {loading ? <CircularProgress size={24} /> : 'Send Catering Request'}
                      </Button>
                  </Box>
              </Grid>

          </Grid>

          <Dialog open={dialogOpen} onClose={() => {
              setDialogOpen(false);
              navigate(isAuthenticated ? '/cateringOrders' : '/cateringsEnquiry');
          }}>
              <DialogTitle>Success</DialogTitle>
              <DialogContent>{successMessage}</DialogContent>
              <DialogActions>
                  <Button onClick={() => {
                      setDialogOpen(false);
                      navigate(isAuthenticated ? '/cateringOrders' : '/cateringsEnquiry');
                  }}>
                      OK
                  </Button>
              </DialogActions>
          </Dialog>
      </form>
    </Box>
  </Container>
  </CardContent>
  </Card>
  </Box>
  )
}
